module.exports = __webpack_public_path__ + "img/curved_arrow.8b4ef27a.png";